export { default } from './TitleTextCenteredColoredCard';
